import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { doc, getDoc } from 'firebase/firestore'

import { auth, db } from '../firebase-config'

const AdminRoute = ({ children }) => {
  const [status, setStatus] = useState('loading')

  useEffect(() => {
    let cancelled = false

    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        if (!cancelled) {
          setStatus('unauthenticated')
        }
        return
      }

      try {
        const userSnapshot = await getDoc(doc(db, 'users', user.uid))
        const userData = userSnapshot.data()

        if (cancelled) {
          return
        }

        setStatus(userData?.role === 'admin' ? 'authorized' : 'forbidden')
      } catch (error) {
        console.error('Failed to load admin access for analytics route', error)
        if (!cancelled) {
          setStatus('forbidden')
        }
      }
    })

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [])

  if (status === 'loading') {
    return <section className="analyticsMessage">Checking access...</section>
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace />
  }

  if (status === 'forbidden') {
    return <Navigate to="/admin" replace />
  }

  return children
}

export default AdminRoute
